import { IS_ACTIVATION_ROLE, IS_ADMIN_ROLE, IS_SALES_ROLE } from "./user_roles";
export const isInternalUser = (role) => {
	if (!role) return false;
	return (
		role.id === IS_ADMIN_ROLE ||
		role.parent_id === IS_ADMIN_ROLE ||
		role.id === IS_ACTIVATION_ROLE ||
		role.parent_id === IS_ACTIVATION_ROLE ||
		role.id === IS_SALES_ROLE ||
		role.parent_id === IS_SALES_ROLE
	);
};
